import currencySymbol from './currencySymbolMap/currencySymbol'

export const formatNumber = (number: number, decimals = 0, locales?: Intl.LocalesArgument): string => number.toLocaleString(locales, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })

export const moneyFormat = (price: number, currency: string): string => `${currency === '$' ? 'AR ' : ''}${currencySymbol(currency)} ${price?.toLocaleString('es-AR') || 0}`
  
export const removePlusSign = (phoneNumber: string|null): string => phoneNumber ? removePlusSignString(phoneNumber) : ''
const removePlusSignString = (phoneNumber: string): string => phoneNumber.startsWith('+') ? phoneNumber.slice(1) : phoneNumber

export const handleNumericInput = (event) => {
  const input = event.target;
  input.value = input.value.replace(/\D/g, '');
};
